import { IconProps } from "../types";

export const SvgIcon = ({ src, width, height, className }: IconProps) => (
  <img src={`/img/svg/${src}`} className={ className } alt={src} width={width} height={height} />
);
